import { render, staticRenderFns } from "./BeCardListTeam.vue?vue&type=template&id=c07d38a8&scoped=true"
import script from "./BeCardListTeam.vue?vue&type=script&lang=js"
export * from "./BeCardListTeam.vue?vue&type=script&lang=js"
import style0 from "./BeCardListTeam.vue?vue&type=style&index=0&id=c07d38a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d38a8",
  null
  
)

export default component.exports